export const REASON_BAD_QUALITY = "bad_quality";
export const REASON_SAMPLES = "samples";
export const REASON_VOEDSELBANK = "voedselbank";
export const REASON_OTHER = "other";
export const REASON_DISCARD_EXPIRED = "discard_expired";
export const REASON_RECOUNT_CORRECTION = "recount_correction";

export const ADJUSTMENT_DIRECTION_REMOVE = "remove";
export const ADJUSTMENT_DIRECTION_ADD = "add";

export const CRATE_ADJUSTMENT_REASONS = [
  { value: REASON_BAD_QUALITY, translationKey: "crate_stock.reason_bad_quality" },
  { value: REASON_SAMPLES, translationKey: "crate_stock.reason_samples" },
  { value: REASON_VOEDSELBANK, translationKey: "crate_stock.reason_voedselbank" },
  { value: REASON_OTHER, translationKey: "crate_stock.reason_other" },
];

export const CRATE_ADDITION_REASONS = [
  { value: REASON_RECOUNT_CORRECTION, translationKey: "crate_stock.reason_recount_correction" },
  { value: REASON_OTHER, translationKey: "crate_stock.reason_other" },
];

export const CRATE_LOG_REASONS = [
  { value: REASON_BAD_QUALITY, translationKey: "crate_stock.reason_bad_quality" },
  { value: REASON_SAMPLES, translationKey: "crate_stock.reason_samples" },
  { value: REASON_VOEDSELBANK, translationKey: "crate_stock.reason_voedselbank" },
  { value: REASON_OTHER, translationKey: "crate_stock.reason_other" },
  { value: REASON_DISCARD_EXPIRED, translationKey: "crate_stock.reason_discard_expired" },
  { value: REASON_RECOUNT_CORRECTION, translationKey: "crate_stock.reason_recount_correction" },
];

export const getReasonLabel = (reasonValue, t) => {
  const allReasons = [...CRATE_LOG_REASONS];
  const reason = allReasons.find((r) => r.value === reasonValue);
  return reason ? t(reason.translationKey) : reasonValue;
};

export const STATUS_AVAILABLE = "available";
export const STATUS_IN_USE = "in_use";

export const LOG_ACTION_QUANTITY_ADJUSTED = "QUANTITY_ADJUSTED";
export const LOG_ACTION_SOLD = "SOLD";
export const LOG_ACTION_RESTOCKED_UNPICK = "RESTOCKED_UNPICK";
export const LOG_ACTION_INCOMING_GOODS_REGISTERED = "INCOMING_GOODS_REGISTERED";
